import React, { useMemo } from "react";
import { Tabs } from "@shared/ui/tabs";
import TypesTab from "../../components/workorder/tabs/types/TypesTab";
import SubTypesTab from "../../components/workorder/tabs/subTypes/SubTypesTab";
import SlaRuleTab from "../../components/workorder/tabs/slaRules/SLARules";
import TaxTab from "../../components/workorder/tabs/taxRate/TaxTab";
import TasksTab from "../../components/workorder/tabs/task/TasksTab";
import MaterialsTab from "../../components/workorder/tabs/material/MaterialsTab";
import ReadingsTab from "../../components/workorder/tabs/reading/ReadingsTab";
import {
  ClipboardList,
  FileCog,
  Timer,
  Receipt,
  Shield,
  CheckSquare,
  Package,
  Gauge,
} from "lucide-react";
import SafetyRequirementsLanding from "./tabs/safetyMeasurements/SafetyRequirementsLanding";

// Mock data for work order types (shared across components)
const woTypes = [
  {
    id: 1,
    name: "Installation",
    createdBy: "Admin",
    createdOn: "2024-05-10",
    active: true,
  },
  {
    id: 2,
    name: "Maintenance",
    createdBy: "Admin",
    createdOn: "2024-05-09",
    active: true,
  },
  {
    id: 3,
    name: "Repair",
    createdBy: "Admin",
    createdOn: "2024-05-08",
    active: true,
  },
];

const WorkOrderSettings = () => {
  // Create tab components using the tabComponents pattern
  const tabComponents = useMemo(() => {
    return {
      type: {
        label: "Types",
        shortLabel: "Types",
        icon: <ClipboardList className="h-4 w-4" />,
        component: <TypesTab />,
      },
      "sub-type": {
        label: "Sub-Types",
        shortLabel: "Sub-Types",
        icon: <FileCog className="h-4 w-4" />,
        component: <SubTypesTab />,
      },
      tasks: {
        label: "Tasks",
        shortLabel: "Tasks",
        icon: <CheckSquare className="h-4 w-4" />,
        component: <TasksTab />,
      },
      materials: {
        label: "Materials",
        shortLabel: "Materials",
        icon: <Package className="h-4 w-4" />,
        component: <MaterialsTab />,
      },
      readings: {
        label: "Readings",
        shortLabel: "Readings",
        icon: <Gauge className="h-4 w-4" />,
        component: <ReadingsTab />,
      },
      "sla-rule": {
        label: "SLA Rules",
        shortLabel: "SLA",
        icon: <Timer className="h-4 w-4" />,
        component: <SlaRuleTab />,
      },
      "tax-rate": {
        label: "Tax Rates",
        shortLabel: "Tax",
        icon: <Receipt className="h-4 w-4" />,
        component: <TaxTab />,
      },
      "safety-requirements": {
        label: "Safety Requirements",
        shortLabel: "Safety",
        icon: <Shield className="h-4 w-4" />,
        component: <SafetyRequirementsLanding />,
      },
    };
  }, [woTypes]);

  return (
    <div>
      {/* Settings Header */}
      <div className="mb-6">
        <h2 className="page-title">
          Work Order Configuration
        </h2>
        <p className="page-subtitle">
          Configure work order types, SLA rules, tax settings, safety
          requirements, tasks, materials, and readings
        </p>
      </div>

      <Tabs
        defaultValue="type"
        className="w-full space-y-6"
        urlMapping={{
          type: "types",
          "sub-type": "sub-types",
          tasks: "tasks",
          materials: "materials",
          readings: "readings",
          "sla-rule": "sla-rules",
          "tax-rate": "tax-rates",
          "safety-requirements": "safety-requirements",
        }}
        idPrefix="workorder-settings"
        tabComponents={tabComponents}
        tabsListClassName="grid w-full grid-cols-4 lg:grid-cols-8 bg-gray-50 p-1 rounded-lg shadow-sm"
        disableUrlSync={false}
      />
    </div>
  );
};

export default WorkOrderSettings;
